var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled, { css } from 'styled-components';
import { buildSizeProps, buildBorderProps, buildFontProps, buildColorProps, buildSpacingProps, } from '../../helpers/builders';
import { Scrollbar } from '../../themes/global';
import { acceptableProps, textareaProps } from './modifiers';
import { Modifiers } from '../../helpers/getModifiers';
export var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, props = __rest(_a, ["theme"]);
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", "px;\n    ", ";\n    ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", "px;\n    ", ";\n    ", ";\n  "])), theme.spacing.nano, buildSpacingProps, buildSizeProps(__assign({}, Modifiers.sanitizeProps({
        props: props,
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))));
});
export var Textarea = styled.textarea(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, _focus = _a._focus, _active = _a._active, _disabled = _a._disabled, _hover = _a._hover, props = __rest(_a, ["theme", "_focus", "_active", "_disabled", "_hover"]);
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    all: unset;\n    word-wrap: break-word;\n    box-sizing: border-box;\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n\n    &:disabled {\n      cursor: not-allowed;\n      ", ";\n      ", ";\n      ", ";\n      ", ";\n    }\n\n    &:active {\n      ", ";\n      ", ";\n      ", ";\n      ", ";\n    }\n    &:hover {\n      ", ";\n      ", ";\n      ", ";\n      ", ";\n    }\n\n    &:focus {\n      ", ";\n      ", ";\n      ", ";\n      ", ";\n\n      border-color: ", ";\n    }\n\n    ", ";\n\n    padding: ", "px;\n    padding-right: ", "px;\n\n    ::placeholder {\n      color: ", ";\n    }\n\n    transition: border-color 0.2s ease 0s;\n  "], ["\n    all: unset;\n    word-wrap: break-word;\n    box-sizing: border-box;\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n\n    &:disabled {\n      cursor: not-allowed;\n      ", ";\n      ", ";\n      ", ";\n      ", ";\n    }\n\n    &:active {\n      ", ";\n      ", ";\n      ", ";\n      ", ";\n    }\n    &:hover {\n      ", ";\n      ", ";\n      ", ";\n      ", ";\n    }\n\n    &:focus {\n      ", ";\n      ", ";\n      ", ";\n      ", ";\n\n      border-color: ", ";\n    }\n\n    ", ";\n\n    padding: ", "px;\n    padding-right: ", "px;\n\n    ::placeholder {\n      color: ", ";\n    }\n\n    transition: border-color 0.2s ease 0s;\n  "])), buildSizeProps(__assign({}, Modifiers.sanitizeProps({
        props: props,
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildBorderProps(__assign({}, Modifiers.sanitizeProps({
        props: props,
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildFontProps(__assign({}, Modifiers.sanitizeProps({
        props: props,
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildColorProps(__assign({}, Modifiers.sanitizeProps({
        props: props,
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildSizeProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _disabled),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildBorderProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _disabled),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildFontProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _disabled),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildColorProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _disabled),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildSizeProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _active),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildBorderProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _active),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildFontProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _active),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildColorProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _active),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildSizeProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _hover),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildBorderProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _hover),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildFontProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _hover),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildColorProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _hover),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildSizeProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _focus),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildBorderProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _focus),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildFontProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _focus),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), buildColorProps(__assign({}, Modifiers.sanitizeProps({
        props: __assign(__assign({}, props), _focus),
        theme: theme,
        acceptableProps: acceptableProps,
        defProps: textareaProps,
    }))), (_focus === null || _focus === void 0 ? void 0 : _focus.bColor) || theme.neutrals.gray8, Scrollbar, theme.spacing.xxxs, theme.spacing.nano, theme.neutrals.gray4);
});
export var Footer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  justify-content: ", ";\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: ", ";\n"])), function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
